module.exports = __webpack_public_path__ + "Flag-508.94704c98f76a7a8df39f7662c1529d41.svg";